import PageHead from '@components/PageHead';
import PageLink from '@components/PageLink';
import Episode from '@models/Episode';
import { Podcast } from '@models/Podcast';
import { Topic } from '@models/Topic';
import config from 'config';
import React, { useState } from 'react';
import PodcastIntroTab from './PodcastIntroTab';
import TopicsAndEpisodes from './TopicsAndEpisodes';

function PodcastPage(props: {
  podcast: Podcast;
  topics: Topic[];
  episodes: Episode[];
}) {
  const { podcast } = props;
  const [currentTab, setCurrentTab] = useState('topics-and-episodes');

  return (
    <div className="podcast-page">
      <PageHead
        title={podcast.title + ' | Hoost'}
        description={podcast.description}
        imageUrl={podcast.image}
        pageUrl={config.DEFAULT_PAGE_URL + '/podcast/' + podcast.id}
      />

      <div className="section">
        <div className="container-2 w-container">
          <div className="podcaster-info-detail-wrap">
            <div className="div-block-51">
              <img
                src={podcast.image}
                loading="lazy"
                alt=""
                className="podcaster-photo-detail"
              />
            </div>
            <div className="podcastor-name-wrap">
              <h1 className="podcaster-name">{podcast.title}</h1>
              <div className="social-link-wrap">

                {podcast.extra?.facebook_handle?.length > 0 && (
                  <PageLink
                    className="social-link-box w-inline-block"
                    to={podcast.extra.facebook_handle}
                    newTab>
                    <img
                      src={'/icons/TopicDetailPage/facebook.svg'}
                      loading="lazy"
                      alt=""
                      className="social-logo"
                    />
                  </PageLink>
                )}

                {podcast.extra?.instagram_handle?.length > 0 && (
                  <PageLink
                    className="social-link-box w-inline-block"
                    to={podcast.extra.instagram_handle}
                    newTab>
                    <img
                      src={'/icons/TopicDetailPage/instagram.svg'}
                      loading="lazy"
                      alt=""
                      className="social-logo"
                    />
                  </PageLink>
                )}

                {podcast.extra?.youtube_url?.length > 0 && (
                  <PageLink
                    className="social-link-box w-inline-block"
                    to={podcast.extra.youtube_url}
                    newTab>
                    <img
                      src={'/icons/TopicDetailPage/youtube.svg'}
                      loading="lazy"
                      alt=""
                      className="social-logo"
                    />
                  </PageLink>
                )}

                {podcast.extra?.url1?.length > 0 && (
                  <PageLink
                    className="social-link-box w-inline-block"
                    to={podcast.extra.url1}
                    newTab>
                    <img
                      src={'/icons/TopicDetailPage/website.svg'}
                      loading="lazy"
                      alt=""
                      className="social-logo"
                    />
                  </PageLink>
                )}

              </div>
            </div>
            <div className="div-block"/>
            <div className="follow-button">
              <div className="text-block">追蹤</div>
            </div>
            <div className="div-block-3">
              {podcast.follower_count > 100 ? (
                <div
                  id="w-node-cf7b249d-d0dd-1028-bd5c-75b76c54a708-af8761cf"
                  className="data-follow"
                >
                  <div className="cnannel-data-index">位 追蹤</div>
                  <div className="text-block-3">{podcast.follower_count}</div>
                </div>
              ) : (
                <div/>
              )}

              {podcast.total_listen_count > 1000 ? (
                <div
                  id="w-node-cf7b249d-d0dd-1028-bd5c-75b76c54a703-af8761cf"
                  className="data-listen"
                >
                  <div className="cnannel-data-index">次 收聽</div>
                  <div className="text-block-3">
                    {podcast.total_listen_count}
                  </div>
                </div>
              ) : (
                <div/>
              )}
            </div>
          </div>
          <div className="div-block-18">
            <div className="follow-button-copy">
              <div className="text-block">追蹤</div>
            </div>
          </div>
        </div>
      </div>
      <div className="section-3">
        <nav className="nav-container-p w-container">
          <a
            id="w-node-b1616f6a-8025-c840-82c4-b0fa20e267d4-7885ef48"
            onClick={() => setCurrentTab('topics-and-episodes')}
            className={
              'nav-sub-menu' +
              (currentTab === 'topics-and-episodes' ? ' active' : '')
            }
          >
            課程與單集
          </a>
          <a
            id="w-node-b1616f6a-8025-c840-82c4-b0fa20e267d6-7885ef48"
            onClick={() => setCurrentTab('intro')}
            className={
              'nav-sub-menu' + (currentTab === 'intro' ? ' active' : '')
            }
          >
            頻道介紹
          </a>
          <div className="div-block-2">
            <div className="data-listen">
              <div className="cnannel-data-index">次 收聽</div>
              <div className="text-block-3">{podcast.total_listen_count}</div>
            </div>
            <div className="data-follow">
              <div className="cnannel-data-index">位 追蹤</div>
              <div className="text-block-3">{podcast.follower_count}</div>
            </div>
          </div>
        </nav>
      </div>
      {currentTab === 'topics-and-episodes' ? (
        <TopicsAndEpisodes {...props} />
      ) : (
        <div/>
      )}
      {currentTab === 'intro' ? <PodcastIntroTab podcast={podcast}/> : <div/>}
    </div>
  );
}

export default PodcastPage;
